import type { Editor } from '@tiptap/core';

import type { TiptapContent } from '../../../../common/tiptap/tiptapTypes';

/**
 * Loads persisted cell content, then records any typed overwrite as the first undoable edit.
 */
export const initialiseTiptapCellEditorContent = ({
    editor,
    persistedContent,
    overwriteContent,
}: {
    editor: Editor;
    persistedContent: TiptapContent;
    overwriteContent: TiptapContent | null;
}): void => {
    if (!overwriteContent) {
        editor.commands.syncFromExternalStore(persistedContent);
        return;
    }

    // Init, and then overwrite as a separate transaction - it needs to be a separate entry in the undo stack
    editor.commands.syncFromExternalStore(persistedContent);
    editor.commands.setContent(overwriteContent);
};
